/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of an organizational unit
 * @export
 * @interface B2BOrgUnit
 */
export interface B2BOrgUnit {
    /**
     * Identifier of the organizational unit.
     * @type {string}
     * @memberof B2BOrgUnit
     */
    uid: string;
    /**
     * Name of the organizational unit.
     * @type {string}
     * @memberof B2BOrgUnit
     */
    name?: string;
}

/**
 * Check if a given object implements the B2BOrgUnit interface.
 */
export function instanceOfB2BOrgUnit(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "uid" in value;

    return isInstance;
}

export function B2BOrgUnitFromJSON(json: any): B2BOrgUnit {
    return B2BOrgUnitFromJSONTyped(json, false);
}

export function B2BOrgUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): B2BOrgUnit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': json['uid'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function B2BOrgUnitToJSON(value?: B2BOrgUnit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
        'name': value.name,
    };
}

